/* mo-pl.js: the bed pillows page (sections/mo-pl.liquid), Mattress Overstock, 2026-10-14.
   Reads the JSON the section renders (live variants plus the maker loft blocks), wires "Find your loft"
   (assets/mo-pl-loft.js draws it), the picker sorted closest to the gap, and the server cards: filters, sort,
   size repricing and Compare (up to 3; forked from the all-mattresses finder's dock and sheet, mo-mx-finder.js,
   after the lululemon tray and Hims spec rows on Mobbin). Cards stay the server's own DOM, so the floor badge
   and the delivery slot remain the theme snippets. Plain JS, no libraries. */
(function () {
  'use strict';
  var doc = document, win = window;
  var COMPARE_MAX = 3;
  var SIZES = ['Queen', 'King'];
  var POS_WORD = { side: 'side', back: 'back', stomach: 'stomach' };

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function el(tag, attrs, kids) {
    var n = doc.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null || attrs[k] === false) continue;
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c != null) n.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c); });
    return n;
  }
  function setText(n, t) { if (n && n.textContent !== t) n.textContent = t; }
  function setAttr(n, k, v) { if (n && n.getAttribute(k) !== v) n.setAttribute(k, v); }
  function money(c) {
    var d = c / 100;
    return '$' + (d % 1 === 0 ? d.toLocaleString('en-US') : d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function inch(v) { return (Math.round(v * 100) / 100).toString().replace(/\.0+$/, '') + ' in.'; }
  function reduced() { return win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  var FRAMES = ['small', 'medium', 'large'];
  function guideSize(it, pos, frame) {
    var row = it.guide && it.guide[pos];
    return row ? row[FRAMES.indexOf(frame)] || null : null;
  }
  function cdnW(src, w) { return src ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src; }

  /* ---------- data ---------- */

  function parse(root) {
    var raw = $('[data-pl-json]', root);
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return null; }
    var items = [];
    data.pillows.forEach(function (p, ix) {
      var it = {
        ix: ix, h: p.h, url: p.u, title: p.t, brand: (p.v || '').replace(/[®°]/g, '').trim(),
        img: p.img, img2: p.img2, vars: p.s || [], floor: p.fr || [],
        short: p.sh || p.t.replace(/[®°]/g, ''),
        lofts: [], adj: null, af: !!p.af, pos: [], fill: p.fi || '', resp: p.re || 'slow', cool: p.co || '', note: p.no || '', src: p.src || '', guide: null
      };
      if (p.lo) p.lo.split('|').forEach(function (part) {
        var kv = part.split(':');
        var v = parseFloat(kv[1]);
        if (kv.length === 2 && isFinite(v)) it.lofts.push({ label: kv[0].trim(), v: v });
      });
      if (p.adj) {
        var m = String(p.adj).split('-').map(parseFloat);
        if (m.length === 2 && isFinite(m[0]) && isFinite(m[1])) it.adj = { min: m[0], max: m[1] };
      }
      // a maker size guide by position and frame (Bedgear's own fit quiz): side:1.0,2.0,2.0|back:...
      if (p.sg) {
        it.guide = {};
        p.sg.split('|').forEach(function (row) {
          var kv = row.split(':');
          if (kv.length === 2) it.guide[kv[0].trim()] = kv[1].split(',').map(function (x) { return x.trim(); });
        });
      }
      if (p.pos) it.pos = p.pos.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      it.sized = it.vars.some(function (v) { return v[0].indexOf('Queen') !== -1 || v[0].indexOf('King') !== -1; });
      it.hasLoft = it.lofts.length > 0 || !!it.adj;
      items.push(it);
    });
    return { items: items, sources: data.sources || [] };
  }

  // Price for a size (and a loft option if the pillow sells several). Pillows without Queen/King are one size.
  function priceOf(it, size, opt) {
    var vs = it.vars.filter(function (v) { return !it.sized || v[0].indexOf(size) !== -1; });
    if (!vs.length) return null;
    var pick = opt ? vs.filter(function (v) { return v[0].indexOf(opt) !== -1; }) : [];
    var use = pick.length ? pick : vs;
    var lo = Infinity, hi = -Infinity, was = null, avail = false;
    use.forEach(function (v) {
      lo = Math.min(lo, v[1]); hi = Math.max(hi, v[1]);
      if (typeof v[2] === 'number' && v[2] > v[1]) was = v[2];
      if (v[3]) avail = true;
    });
    return { lo: lo, hi: hi, was: was, avail: avail, sized: it.sized };
  }

  // How close a pillow comes to the gap: the best published loft, or an adjustable pillow set inside its range.
  // Is a loft option sold online in this size? ('all' means any variant of the size.)
  function optAvail(it, size, label) {
    return it.vars.some(function (v) {
      var o = v[0];
      return v[3] && (!it.sized || o.indexOf(size) !== -1) && (!label || label === 'all' || o.indexOf(label) !== -1);
    });
  }

  // How close a pillow comes to the gap in a size: the closest published loft that is sold online in that size
  // (or the closest of all when none is), or an adjustable pillow set inside its range. avail: can it be bought now.
  function fitOf(it, gap, size) {
    if (it.adj) {
      var v = Math.min(it.adj.max, Math.max(it.adj.min, gap));
      return { v: v, d: Math.abs(v - gap), label: null, adj: true, avail: optAvail(it, size, null) };
    }
    if (!it.lofts.length) return null;
    var open = it.lofts.filter(function (o) { return optAvail(it, size, o.label); });
    var pool = open.length ? open : it.lofts;
    var best = null;
    pool.forEach(function (o) {
      var d = Math.abs(o.v - gap);
      if (!best || d < best.d - 1e-9) best = { v: o.v, d: d, label: o.label, adj: false, avail: open.length > 0 };
    });
    return best;
  }

  // Option names worth showing: Low, Medium, Tall. Not 'all', and not a size like 4" that repeats the inches.
  function named(l) { return !!l && l !== 'all' && !/^\d/.test(l); }
  function optText(it, o) {
    if (!o) return '';
    return (named(o.label) ? o.label + ', ' : '') + inch(o.v);
  }

  /* ---------- page ---------- */

  function boot(root) {
    if (root.__pl) return;
    root.__pl = true;
    var D = parse(root);
    if (!D) return;
    var items = D.items, byH = {};
    items.forEach(function (it) { byH[it.h] = it; });
    var E = win.MOPlLoft;
    var stage = $('[data-pl-stage]', root);
    var url = new URL(win.location.href);
    var q = function (k, ok, d) { var v = url.searchParams.get('pl_' + k); return ok.indexOf(v) !== -1 ? v : d; };
    var state = {
      pos: q('pos', ['side', 'back', 'stomach'], 'side'),
      frame: q('frame', ['small', 'medium', 'large'], 'medium'),
      feel: q('feel', ['soft', 'medium', 'firm'], 'medium'),
      size: q('size', SIZES, 'Queen'),
      sort: 'gap', pick: null, opt: null, noLoft: null,
      f: { pos: null, adj: false, cool: false, brand: [] },
      picked: []
    };
    // Shopify's own sort parameter wins over the gap sort when a visitor arrives with it
    var sb = url.searchParams.get('sort_by');
    if (sb === 'price-ascending') state.sort = 'price-asc';
    else if (sb === 'price-descending') state.sort = 'price-desc';
    root.classList.add('is-js');

    function gap() { return E ? E.gapFor(state.pos, state.frame, state.feel) : 5; }

    function score(it, g) {
      var f = fitOf(it, g, state.size);
      var p = !it.pos.length ? 0.75 : it.pos.indexOf(state.pos) !== -1 ? 0 : 1.5;
      return f.d + p;
    }
    function ranked() {
      var g = gap();
      var withLoft = items.filter(function (it) { return it.hasLoft; });
      // Score: inches from the gap, plus a step when the maker names other positions (1.5 in.) or none (0.75 in.),
      // so a pillow its maker sizes for your position comes ahead of one that only matches on inches.
      // Pillows you can buy now in the chosen size come first; sold-out ones follow with their note.
      withLoft.sort(function (a, b) {
        var fa = fitOf(a, g, state.size), fb = fitOf(b, g, state.size);
        return ((fa.avail ? 0 : 1) - (fb.avail ? 0 : 1)) || (score(a, g) - score(b, g)) || (a.ix - b.ix);
      });
      return withLoft.concat(items.filter(function (it) { return !it.hasLoft; }));
    }

    /* ----- studio controls ----- */
    var groups = {};
    $$('[data-pl-group]', root).forEach(function (g) { groups[g.getAttribute('data-pl-group')] = g; });
    function paintGroup(name, v) {
      var g = groups[name];
      if (!g) return;
      $$('button', g).forEach(function (b) { setAttr(b, 'aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); });
    }

    var engine = null;
    var view = $('[data-pl-view]', root);
    var verdict = $('[data-pl-verdict]', root), readLink = $('[data-pl-readlink]', root);
    var readBrand = $('[data-pl-readbrand]', root), readName = $('[data-pl-readname]', root);
    var readLoft = $('[data-pl-readloft]', root), readPrice = $('[data-pl-readprice]', root), readSize = $('[data-pl-readsize]', root);
    var optsBox = $('[data-pl-opts]', root);
    var pickRow = $('[data-pl-pickrow]', root), pickHint = $('[data-pl-pickhint]', root);

    function current() {
      var it = state.pick && byH[state.pick];
      if (!it || !it.hasLoft) { it = ranked()[0]; state.pick = it ? it.h : null; }
      return it;
    }
    function loftFor(it) {
      var g = gap();
      if (it.adj) return fitOf(it, g, state.size);
      var o = state.opt && it.lofts.filter(function (x) { return x.label === state.opt; })[0];
      if (o) return { v: o.v, d: Math.abs(o.v - g), label: o.label, avail: optAvail(it, state.size, o.label) };
      return fitOf(it, g, state.size);
    }

    function angleFor(loft) {
      if (!E) return 0;
      var p = E.paths({ pos: state.pos, frame: state.frame, gap: gap(), sink: E.SINK[state.feel], loft: loft, dent: 0, lift: 0, bend: 0 });
      return p.angle;
    }

    function paintStudio(opts) {
      var it = current();
      if (!it) return;
      var g = gap(), f = loftFor(it);
      if (view) setText(view, stage.getAttribute('data-view-' + state.pos) || '');
      if (engine) engine.set({
        pos: state.pos, frame: state.frame, gap: g, sink: E.SINK[state.feel], loft: f.v, fill: it.resp, adj: it.adj, key: it.h + '|' + f.v,
        loftText: inch(f.v)
      }, opts);
      stage.classList.toggle('is-dim', !!state.noLoft);
      if (state.noLoft && byH[state.noLoft]) { paintNoLoft(byH[state.noLoft]); paintPick(); return; }
      // readout
      var ang = Math.round(Math.abs(angleFor(f.v)));
      var line;
      if (f.d <= 0.5) line = 'Neck in line with the spine.';
      else if (f.v > g) line = 'Head tips up about ' + ang + '°. A lower loft sits closer.';
      else line = 'Head drops about ' + ang + '°. A taller loft sits closer.';
      if (f.d > 0.5 && it.lofts.length > 1) {
        var bf = fitOf(it, g, state.size);
        if (bf.label !== f.label) line = line.replace(/A (lower|taller) loft sits closer\./, (named(bf.label) ? 'The ' + bf.label : 'The ' + inch(bf.v) + ' size') + ' sits closer.');
      }
      setText(verdict, line);
      var dial = $('[data-pl-dial]', root);
      if (dial) { setText(dial, (f.d <= 0.5 ? 0 : ang) + '\u00b0'); dial.parentNode.classList.toggle('is-off', f.d > 0.5); }
      setAttr(readLink, 'href', it.url);
      setText(readBrand, it.brand);
      setText(readName, it.short);
      var lt = it.adj ? 'Adjustable fill, ' + inch(it.adj.min) + ' to ' + inch(it.adj.max) + '. Drawn set to ' + inch(f.v) + '.'
        : (named(f.label) ? f.label + ': ' : '') + inch(f.v) + ' published loft.';
      setText(readLoft, lt);
      if (it.src && readLoft) readLoft.appendChild(el('sup', { class: 'pl-fn' }, [el('a', { class: 'pl-fnlink', href: '#pl-src-' + it.src, text: it.src })]));
      // loft options
      optsBox.textContent = '';
      if (it.lofts.length > 1) {
        optsBox.hidden = false;
        it.lofts.forEach(function (o) {
          optsBox.appendChild(el('button', {
            type: 'button', class: 'pl-opt pl-opt--btn', 'data-act': 'opt', 'data-v': o.label,
            'aria-pressed': o.label === f.label ? 'true' : 'false'
          }, named(o.label) ? [el('span', { class: 'pl-opt__l', text: o.label }), el('span', { class: 'pl-opt__v', text: inch(o.v) })] : [el('span', { class: 'pl-opt__l', text: inch(o.v) })]));
        });
      } else optsBox.hidden = true;
      var pr = priceOf(it, state.size, f.label && f.label !== 'all' ? f.label : null);
      setText(readPrice, pr ? (pr.lo !== pr.hi ? 'From ' : '') + money(pr.lo) : '');
      setText(readSize, pr ? (pr.sized ? state.size : 'One size') + (pr.avail ? '' : ', sold out online') : '');
      paintPick();
    }

    /* ----- picker ----- */
    var pickBtns = {};
    function buildPick() {
      pickRow.textContent = '';
      ranked().forEach(function (it) {
        var im = it.img ? el('img', { src: cdnW(it.img, 200), alt: '', width: '96', height: '72', loading: 'lazy', decoding: 'async' }) : null;
        var b = el('li', { class: 'pl-pk' + (it.hasLoft ? '' : ' is-none'), role: 'option', 'data-h': it.h, 'aria-selected': 'false', tabindex: '-1' }, [
          el('span', { class: 'pl-pk__img' }, [im]),
          el('span', { class: 'pl-pk__txt' }, [
            el('span', { class: 'pl-pk__brand', text: it.brand }),
            el('span', { class: 'pl-pk__name', text: it.short }),
            el('span', { class: 'pl-pk__loft' })
          ])
        ]);
        pickBtns[it.h] = b;
        pickRow.appendChild(b);
      });
    }
    function paintPick() {
      var g = gap(), list = ranked(), cur = state.noLoft || state.pick;
      list.forEach(function (it, k) {
        var b = pickBtns[it.h];
        if (!b) return;
        if (pickRow.children[k] !== b) pickRow.insertBefore(b, pickRow.children[k] || null);
        var f = fitOf(it, g, state.size);
        var gs = guideSize(it, state.pos, state.frame);
        setText($('.pl-pk__loft', b), (f ? (it.adj ? 'Adjustable to ' + inch(f.v) : optText(it, f)) : gs ? 'Size ' + gs + ' by ' + it.brand + '\u2019s guide' : 'Loft not published') +
          (f && !f.avail ? ', sold out online' : ''));
        b.classList.toggle('is-out', !!(f && !f.avail));
        b.classList.toggle('is-top', k === 0);
        setAttr(b, 'aria-selected', it.h === cur ? 'true' : 'false');
        setAttr(b, 'tabindex', it.h === cur ? '0' : '-1');
      });
      setText(pickHint, 'Gap in the drawing: about ' + inch(g));
    }
    function choose(h, focus) {
      var it = byH[h];
      if (!it) return;
      if (!it.hasLoft) { state.noLoft = h; paintStudio({ drop: false }); syncUrl(); return; }
      state.noLoft = null;
      state.pick = h; state.opt = null;
      paintStudio();
      if (focus && pickBtns[h]) pickBtns[h].focus();
      syncUrl();
    }

    // A pillow with no published loft: the readout names it and gives its maker's own size guide; the drawing
    // keeps the last pillow, dimmed, because there is no number to draw.
    function paintNoLoft(it) {
      var gs = guideSize(it, state.pos, state.frame);
      setText(verdict, it.brand + ' does not publish a loft in inches for the ' + it.short + ', so it stays off the drawing.' +
        (gs ? ' ' + it.brand + '\u2019s own fit guide picks size ' + gs + ' for a ' + state.frame + ' frame ' + state.pos + ' sleeper.' : ''));
      setAttr(readLink, 'href', it.url);
      setText(readBrand, it.brand);
      setText(readName, it.short);
      setText(readLoft, gs ? 'Size ' + gs + ' by ' + it.brand + '\u2019s guide.' : 'Loft not published.');
      if (it.src && readLoft) readLoft.appendChild(el('sup', { class: 'pl-fn' }, [el('a', { class: 'pl-fnlink', href: '#pl-src-' + it.src, text: it.src })]));
      optsBox.textContent = ''; optsBox.hidden = true;
      var pr = priceOf(it, state.size);
      setText(readPrice, pr ? (pr.lo !== pr.hi ? 'From ' : '') + money(pr.lo) : '');
      setText(readSize, pr ? (pr.sized ? state.size : 'One size') + (pr.avail ? '' : ', sold out online') : '');
      var dial = $('[data-pl-dial]', root);
      if (dial) { setText(dial, '\u2013'); dial.parentNode.classList.remove('is-off'); }
    }

    /* ----- grid ----- */
    var grid = $('[data-pl-grid]', root);
    var cards = {};
    $$('[data-pl-card]', root).forEach(function (c) { cards[c.getAttribute('data-pl-card')] = c; });
    var bar = $('[data-pl-bar]', root), chipsBox = $('[data-pl-chips]', root), sortSel = $('[data-pl-sort]', root);
    var status = $('[data-pl-status]', root), countEl = $('[data-pl-count]', root);

    var brands = [];
    items.forEach(function (it) { if (brands.indexOf(it.brand) === -1) brands.push(it.brand); });
    var CHIPS = [
      { k: 'pos', v: 'side', t: 'Side sleepers' }, { k: 'pos', v: 'back', t: 'Back sleepers' }, { k: 'pos', v: 'stomach', t: 'Stomach sleepers' },
      { k: 'adj', v: '1', t: 'Adjustable' }, { k: 'cool', v: '1', t: 'Cooling' }
    ].concat(brands.map(function (b) { return { k: 'brand', v: b, t: b }; }));
    var chipEls = CHIPS.map(function (c) {
      var b = el('button', { type: 'button', class: 'pl-chip pl-chip--f', 'data-act': 'chip', 'data-k': c.k, 'data-v': c.v, 'aria-pressed': 'false', text: c.t });
      chipsBox.appendChild(b);
      return b;
    });
    var clearChip = el('button', { type: 'button', class: 'pl-chip pl-chip--clear', 'data-act': 'clear', hidden: true, text: 'Clear filters' });
    chipsBox.appendChild(clearChip);
    bar.hidden = false;

    function passes(it) {
      var f = state.f;
      if (f.pos && it.pos.indexOf(f.pos) === -1) return false;
      if (f.adj && !it.adj && !it.af) return false;
      if (f.cool && !it.cool) return false;
      if (f.brand.length && f.brand.indexOf(it.brand) === -1) return false;
      return true;
    }

    function sorted() {
      var g = gap(), list = items.slice();
      if (state.sort === 'gap') return ranked();
      list.sort(function (a, b) {
        if (state.sort === 'loft') {
          var la = a.adj ? a.adj.min : a.lofts.length ? a.lofts[0].v : 99, lb = b.adj ? b.adj.min : b.lofts.length ? b.lofts[0].v : 99;
          return (la - lb) || (a.ix - b.ix);
        }
        var pa = priceOf(a, state.size), pb = priceOf(b, state.size);
        var va = pa ? pa.lo : 1e12, vb = pb ? pb.lo : 1e12;
        return (state.sort === 'price-desc' ? vb - va : va - vb) || (a.ix - b.ix);
      });
      void g;
      return list;
    }

    function ruler(it, g) {
      var box = el('span', { class: 'pl-ruler', 'aria-hidden': 'true' });
      var MAX = 8;
      var pct = function (v) { return Math.max(0, Math.min(100, v / MAX * 100)).toFixed(1) + '%'; };
      box.appendChild(el('span', { class: 'pl-ruler__track' }));
      if (it.adj) {
        var r = el('span', { class: 'pl-ruler__range' });
        r.style.left = pct(it.adj.min); r.style.width = (Math.max(0, it.adj.max - it.adj.min) / MAX * 100).toFixed(1) + '%';
        box.appendChild(r);
      }
      it.lofts.forEach(function (o) { var d = el('span', { class: 'pl-ruler__dot' }); d.style.left = pct(o.v); box.appendChild(d); });
      var gm = el('span', { class: 'pl-ruler__gap' }); gm.style.left = pct(g); box.appendChild(gm);
      return box;
    }

    function paintGrid() {
      var g = gap(), list = sorted(), shown = 0;
      list.forEach(function (it, k) {
        var c = cards[it.h];
        if (!c) return;
        if (grid.children[k] !== c) grid.insertBefore(c, grid.children[k] || null);
        var ok = passes(it);
        if (c.hidden === ok) c.hidden = !ok;
        if (ok) shown++;
        // price for the size
        var pr = priceOf(it, state.size), pe = $('[data-pl-price]', c);
        if (pr && pe) {
          setText($('.pl-card__amt', pe), (pr.lo !== pr.hi ? 'From ' : '') + money(pr.lo));
          setText($('.pl-card__size', pe), pr.sized ? state.size : 'One size');
          // Black Friday cards (server tag, lane catalog): strike the shown variant's own compare-at in this size
          if (c.querySelector('[data-mo-bf]')) {
            var lov = null;
            it.vars.forEach(function (v) { if ((!it.sized || v[0].indexOf(state.size) !== -1) && (!lov || v[1] < lov[1])) lov = v; });
            var own = lov && typeof lov[2] === 'number' && lov[2] > lov[1] ? lov[2] : null, sEl = $('.pl-card__was', pe);
            if (own && !sEl) {
              sEl = el('s', { class: 'pl-card__was' }, [el('span', { class: 'pl-vh', text: 'Compare at ' }), money(own)]);
              pe.insertBefore(sEl, $('.pl-card__size', pe));
            } else if (own && sEl) {
              if (sEl.lastChild && sEl.lastChild.nodeType === 3) { if (sEl.lastChild.nodeValue !== money(own)) sEl.lastChild.nodeValue = money(own); }
            } else if (!own && sEl) sEl.remove();
          }
          var out = $('.pl-card__out', pe);
          if (!pr.avail && !out) pe.appendChild(el('span', { class: 'pl-card__out', text: 'Sold out online' }));
          if (pr.avail && out) out.remove();
        }
        // fit against the gap
        var fitBox = $('[data-pl-fit]', c), f = fitOf(it, g, state.size);
        if (fitBox) {
          fitBox.textContent = '';
          if (f) {
            fitBox.hidden = false;
            var txt = f.d <= 0.5 ? 'Fits your gap' : f.v > g ? 'Taller than your gap' : 'Lower than your gap';
            fitBox.appendChild(el('span', { class: 'pl-fit__t' + (f.d <= 0.5 ? ' is-ok' : '') }, [
              txt + (it.adj ? ', set to ' + inch(f.v) : it.lofts.length > 1 ? (named(f.label) ? ' in the ' + f.label : ' at ' + inch(f.v)) : '')
            ]));
            fitBox.appendChild(ruler(it, g));
          } else if (guideSize(it, state.pos, state.frame)) {
            fitBox.hidden = false;
            fitBox.appendChild(el('span', { class: 'pl-fit__t is-ok' }, [it.brand + '\u2019s guide for you: size ' + guideSize(it, state.pos, state.frame),
              it.src ? el('sup', { class: 'pl-fn' }, [el('a', { class: 'pl-fnlink', href: '#pl-src-' + it.src, text: it.src })]) : null]));
          } else fitBox.hidden = true;
        }
      });
      var sizeTxt = state.size + ' prices';
      var sortTxt = { gap: 'closest to your gap first', 'price-asc': 'price low to high', 'price-desc': 'price high to low', loft: 'loft low to high' }[state.sort];
      setText(countEl, shown + (shown === 1 ? ' pillow' : ' pillows'));
      setText(status, shown + ' shown, ' + sizeTxt + ', ' + sortTxt + (state.sort === 'gap' ? ' (' + POS_WORD[state.pos] + ' sleeper, ' + state.frame + ' frame, ' + state.feel + ' mattress)' : '') + '.');
      var any = state.f.pos || state.f.adj || state.f.cool || state.f.brand.length;
      clearChip.hidden = !any;
      chipEls.forEach(function (b) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
        var on = k === 'pos' ? state.f.pos === v : k === 'brand' ? state.f.brand.indexOf(v) !== -1 : !!state.f[k];
        setAttr(b, 'aria-pressed', on ? 'true' : 'false');
      });
      syncCmp();
    }

    /* ----- compare (forked from mo-mx-finder.js) ----- */
    var cmpSlots = [];
    for (var cs = 0; cs < COMPARE_MAX; cs++) cmpSlots.push(el('span', { class: 'pl-dock__slot', 'data-h': '' }));
    var dockCount = el('span', { class: 'pl-dock__count' });
    var dockN = el('span', { class: 'pl-dock__n' });
    var dockOpen = el('button', { type: 'button', class: 'pl-btn pl-btn--sm', 'data-act': 'cmp-open' }, ['Compare', dockN]);
    var dockIn = el('div', { class: 'pl-dock__in' }, [
      el('div', { class: 'pl-dock__slots' }, cmpSlots),
      el('div', { class: 'pl-dock__text' }, [dockCount, el('button', { type: 'button', class: 'pl-link pl-link--sm', 'data-act': 'cmp-clear', text: 'Clear' })]),
      dockOpen
    ]);
    var dock = el('div', { class: 'pl-dock', role: 'region', 'aria-label': 'Compare pillows', hidden: true }, [dockIn]);
    var cmpSeg = el('div', { class: 'pl-seg pl-seg--size', role: 'group', 'aria-label': 'Pillow size' }, SIZES.map(function (sz) {
      return el('button', { type: 'button', class: 'pl-seg__btn pl-size', 'data-act': 'size', 'data-v': sz, 'aria-pressed': 'false', text: sz });
    }));
    var cmpSummary = el('p', { class: 'pl-cmp__summary' });
    var cmpBody = el('div', { class: 'pl-cmp__grid' });
    var cmp = el('dialog', { class: 'pl-cmp', 'aria-labelledby': 'pl-cmp-t' }, [
      el('div', { class: 'pl-cmp__panel' }, [
        el('div', { class: 'pl-cmp__head' }, [
          el('h3', { class: 'pl-cmp__title', id: 'pl-cmp-t' }, ['Side by ', el('em', { text: 'side' })]),
          el('button', { type: 'button', class: 'pl-iconbtn pl-iconbtn--x', 'data-act': 'cmp-close', 'aria-label': 'Close compare', text: '×' })
        ]),
        el('div', { class: 'pl-cmp__size' }, [el('span', { class: 'pl-label', text: 'Size' }), cmpSeg]),
        cmpSummary,
        el('div', { class: 'pl-cmp__scroll' }, [cmpBody])
      ])
    ]);
    root.appendChild(dock);
    root.appendChild(cmp);
    $$('[data-pl-cmp]', root).forEach(function (b) { b.hidden = false; });

    // A pillow dropped into the dock lands the way its fill moves (memory foam settles slowly, latex bounces,
    // the grid lands and holds). After 21st.dev Toast Gravity Stack 33302 and Spring Element 2923, as keyframes.
    var LANDINGS = {
      slow: { d: 1100, k: [[-26, 1, 1, 0, 0], [0, 1.07, .84, 1, .34], [0, 1.03, .93, 1, .66], [0, 1, 1, 1, 1]] },
      quick: { d: 760, k: [[-26, 1, 1, 0, 0], [0, 1.05, .9, 1, .26], [-10, .98, 1.03, 1, .42], [0, 1.02, .97, 1, .58], [-4, 1, 1, 1, .72], [0, 1, 1, 1, 1]] },
      grid: { d: 520, k: [[-26, 1, 1, 0, 0], [0, 1.03, .95, 1, .4], [0, 1, 1, 1, 1]] },
      fiber: { d: 820, k: [[-26, 1, 1, 0, 0], [0, 1.08, .86, 1, .3], [-5, .99, 1.02, 1, .5], [0, 1, 1, 1, 1]] }
    };
    function land(node, resp) {
      if (reduced() || typeof node.animate !== 'function') return;
      var L = LANDINGS[resp] || LANDINGS.slow;
      node.style.transformOrigin = '50% 100%';
      node.animate(L.k.map(function (f) { return { transform: 'translateY(' + f[0] + 'px) scale(' + f[1] + ',' + f[2] + ')', opacity: f[3], offset: f[4] }; }), { duration: L.d, easing: 'ease-out' });
    }
    function paintDock(added) {
      var n = state.picked.length;
      dock.hidden = !n;
      doc.documentElement.classList.toggle('pl-has-dock', n > 0);
      cmpSlots.forEach(function (slot, k) {
        var h = state.picked[k] || '', it = h ? byH[h] : null;
        if (slot.getAttribute('data-h') === h) return;
        slot.textContent = '';
        slot.setAttribute('data-h', h);
        slot.classList.toggle('is-on', !!it);
        if (!it) return;
        slot.appendChild(el('span', { class: 'pl-dock__p' }, [el('img', { src: cdnW(it.img, 200), alt: '', width: '72', height: '54', decoding: 'async' })]));
        if (h === added) land(slot.firstChild, it.resp);
      });
      setText(dockCount, n < 2 ? 'Pick one more to compare' : n + ' of ' + COMPARE_MAX + ' picked');
      setText(dockN, ' ' + n);
      if (n < 2) setAttr(dockOpen, 'aria-disabled', 'true'); else dockOpen.removeAttribute('aria-disabled');
    }
    function syncCmp() {
      Object.keys(cards).forEach(function (h) {
        var b = $('[data-pl-cmp]', cards[h]);
        if (b) setAttr(b, 'aria-pressed', state.picked.indexOf(h) !== -1 ? 'true' : 'false');
      });
    }
    function nudgeDock() {
      if (reduced() || typeof dockIn.animate !== 'function') return;
      dockIn.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 320 });
    }
    function toggleCompare(h) {
      var ix = state.picked.indexOf(h), added = null;
      if (ix !== -1) state.picked.splice(ix, 1);
      else if (state.picked.length >= COMPARE_MAX) { nudgeDock(); setText(dockCount, 'Compare holds ' + COMPARE_MAX + '. Remove one first.'); return; }
      else { state.picked.push(h); added = h; }
      syncCmp();
      paintDock(added);
      if (cmp.open) { if (state.picked.length < 2) closeCompare(); else paintCompare(); }
    }

    function loftDrawing(it, g) {
      var ns = 'http://www.w3.org/2000/svg', svg = doc.createElementNS(ns, 'svg');
      var Wd = 140, Hd = 84, base = 78, sc = 9; // 9 px per inch, one scale for every column
      svg.setAttribute('viewBox', '0 0 ' + Wd + ' ' + Hd);
      svg.setAttribute('class', 'pl-cmp__svg');
      svg.setAttribute('aria-hidden', 'true');
      function add(tag, at) { var n = doc.createElementNS(ns, tag); for (var k in at) n.setAttribute(k, String(at[k])); svg.appendChild(n); return n; }
      add('line', { x1: 2, y1: base + .5, x2: Wd - 2, y2: base + .5, class: 'pl-cmp__floor' });
      add('line', { x1: 2, y1: base - g * sc, x2: Wd - 2, y2: base - g * sc, class: 'pl-cmp__gapline' });
      var vals = it.adj ? [it.adj.max, it.adj.min] : it.lofts.map(function (o) { return o.v; }).sort(function (a, b) { return b - a; });
      vals.forEach(function (v, k) {
        var h = v * sc, x0 = 14 + k * 3, x1 = Wd - 14 - k * 3;
        add('path', { d: 'M' + x0 + ' ' + base + ' C' + x0 + ' ' + (base - h) + ' ' + (x0 + 10) + ' ' + (base - h) + ' ' + (x0 + 26) + ' ' + (base - h) + ' L' + (x1 - 26) + ' ' + (base - h) + ' C' + (x1 - 10) + ' ' + (base - h) + ' ' + x1 + ' ' + (base - h) + ' ' + x1 + ' ' + base + ' Z', class: 'pl-cmp__pillow' + (k ? ' is-back' : '') });
      });
      return svg;
    }
    function cell(cls, kids) { return el('div', { class: 'pl-cmp__cell ' + cls }, kids); }
    function lab(t) { return el('div', { class: 'pl-cmp__lab', text: t }); }
    function summary(list) {
      var out = [], g = gap();
      var pr = list.map(function (it) { return { it: it, p: priceOf(it, state.size) }; }).filter(function (x) { return x.p; });
      if (pr.length > 1) {
        pr.sort(function (a, b) { return a.p.lo - b.p.lo; });
        var d = pr[pr.length - 1].p.lo - pr[0].p.lo;
        if (d > 0) out.push('In ' + state.size + ', the ' + pr[0].it.short + ' costs ' + money(d) + ' less than the ' + pr[pr.length - 1].it.short + '.');
      }
      var fits = list.filter(function (it) { return it.hasLoft; }).map(function (it) { return { it: it, f: fitOf(it, g, state.size) }; }).sort(function (a, b) { return a.f.d - b.f.d; });
      if (fits.length > 1) out.push('For a ' + state.pos + ' sleeper with a ' + state.frame + ' frame on a ' + state.feel + ' mattress, the ' + fits[0].it.short + ' comes closest to the gap in the drawing.');
      return out.join(' ');
    }
    function paintCompare() {
      var g = gap(), list = state.picked.map(function (h) { return byH[h]; }).filter(Boolean);
      cmpBody.textContent = '';
      cmpBody.style.setProperty('--cols', String(list.length));
      setText(cmpSummary, summary(list));
      $$('button', cmpSeg).forEach(function (b) { setAttr(b, 'aria-pressed', b.getAttribute('data-v') === state.size ? 'true' : 'false'); });
      var rows = [
        ['', 'is-p', function (it) {
          return [el('a', { class: 'pl-cmp__photo', href: it.url, tabindex: '-1' }, [it.img ? el('img', { src: cdnW(it.img, 400), alt: '', loading: 'lazy', width: '400', height: '300' }) : null]),
            el('span', { class: 'pl-card__brand', text: it.brand }), el('a', { class: 'pl-cmp__name', href: it.url, text: it.short }),
            el('button', { type: 'button', class: 'pl-link pl-link--sm', 'data-act': 'cmp-remove', 'data-v': it.h, text: 'Remove' })];
        }],
        ['Price, ' + state.size, 'is-price', function (it) {
          var p = priceOf(it, state.size);
          if (!p) return [el('span', { class: 'pl-cmp__muted', text: 'Not made in ' + state.size })];
          return [el('span', { class: 'pl-cmp__big', text: (p.lo !== p.hi ? 'From ' : '') + money(p.lo) }),
            p.was ? el('s', { class: 'pl-card__was' }, [el('span', { class: 'pl-vh', text: 'Compare at ' }), money(p.was)]) : null,
            el('span', { class: 'pl-cmp__muted', text: (p.sized ? '' : 'One size') + (p.avail ? '' : (p.sized ? '' : ', ') + 'Sold out online') })];
        }],
        ['Loft', 'is-loft', function (it) {
          if (!it.hasLoft) return [el('span', { class: 'pl-cmp__muted', text: 'Not published' })];
          var t = it.adj ? 'Adjustable, ' + inch(it.adj.min) + ' to ' + inch(it.adj.max) : it.lofts.map(function (o) { return optText(it, o); }).join(' / ');
          return [loftDrawing(it, g), el('span', { text: t })];
        }],
        ['Positions', 'is-pos', function (it) { return [el('span', { text: it.pos.length ? it.pos.map(function (p) { return p.charAt(0).toUpperCase() + p.slice(1); }).join(', ') : 'Not listed' })]; }],
        ['Fill', 'is-fill', function (it) { return [el('span', { text: it.fill || 'Not listed' })]; }],
        ['Cooling', 'is-cool', function (it) { return [el('span', { text: it.cool || 'No cooling claim' })]; }],
        ['Showroom', 'is-floor', function (it) {
          var src = cards[it.h] && $('.pl-card__meta', cards[it.h]);
          var copy = src ? src.cloneNode(true) : null;
          if (copy) $$('[data-mo-eta]', copy).forEach(function (n) { n.remove(); });
          return copy && copy.textContent.trim() ? [copy] : [el('span', { class: 'pl-cmp__muted', text: 'Not on a showroom floor' })];
        }],
        ['', 'is-go', function (it) { return [el('a', { class: 'pl-btn pl-btn--sm', href: it.url, text: 'See this pillow' })]; }]
      ];
      rows.forEach(function (r) {
        cmpBody.appendChild(lab(r[0]));
        list.forEach(function (it) { cmpBody.appendChild(cell(r[1], r[2](it))); });
      });
    }
    function openCompare() {
      if (state.picked.length < 2 || typeof cmp.showModal !== 'function') return;
      paintCompare();
      if (!cmp.open) cmp.showModal();
      doc.documentElement.classList.add('pl-lock');
      win.requestAnimationFrame(function () { cmp.classList.add('is-open'); });
    }
    function closeCompare() {
      if (!cmp.open) return;
      cmp.classList.remove('is-open');
      doc.documentElement.classList.remove('pl-lock');
      if (reduced()) cmp.close(); else win.setTimeout(function () { if (cmp.open) cmp.close(); }, 220);
      try { dockOpen.focus({ preventScroll: true }); } catch (e) { /* nicety */ }
    }
    cmp.addEventListener('cancel', function (e) { e.preventDefault(); closeCompare(); });
    cmp.addEventListener('click', function (e) { if (e.target === cmp) closeCompare(); });
    cmp.addEventListener('close', function () { cmp.classList.remove('is-open'); doc.documentElement.classList.remove('pl-lock'); });

    /* ----- url state ----- */
    var urlTimer = 0;
    function syncUrl() {
      clearTimeout(urlTimer);
      urlTimer = win.setTimeout(function () {
        var u = new URL(win.location.href);
        var set = function (k, v, d) { if (v === d) u.searchParams.delete('pl_' + k); else u.searchParams.set('pl_' + k, v); };
        set('pos', state.pos, 'side'); set('frame', state.frame, 'medium'); set('feel', state.feel, 'medium'); set('size', state.size, 'Queen');
        if (u.href !== win.location.href) win.history.replaceState(win.history.state, '', u.href);
      }, 250);
    }

    /* ----- events ----- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button, [role="option"]');
      if (!b || !root.contains(b)) return;
      var grp = b.closest('[data-pl-group]');
      if (grp && b.matches('button')) {
        var name = grp.getAttribute('data-pl-group'), v = b.getAttribute('data-v');
        if (name === 'size') { state.size = v; paintGroup('size', v); paintGrid(); paintStudio({ drop: false }); if (cmp.open) paintCompare(); syncUrl(); return; }
        state[name] = v; paintGroup(name, v);
        state.opt = null;
        paintStudio({ drop: false }); paintGrid(); syncUrl();
        return;
      }
      if (b.getAttribute('role') === 'option') { choose(b.getAttribute('data-h')); return; }
      var act = b.getAttribute('data-act');
      if (b.hasAttribute('data-pl-cmp')) { toggleCompare(b.getAttribute('data-pl-cmp')); return; }
      switch (act) {
        case 'opt': state.opt = b.getAttribute('data-v'); state.noLoft = null; paintStudio(); break;
        case 'chip': {
          var k = b.getAttribute('data-k'), cv = b.getAttribute('data-v');
          if (k === 'pos') state.f.pos = state.f.pos === cv ? null : cv;
          else if (k === 'brand') { var ix = state.f.brand.indexOf(cv); if (ix === -1) state.f.brand.push(cv); else state.f.brand.splice(ix, 1); }
          else state.f[k] = !state.f[k];
          paintGrid();
          break;
        }
        case 'clear': state.f = { pos: null, adj: false, cool: false, brand: [] }; paintGrid(); break;
        case 'cmp-open': if (state.picked.length < 2) nudgeDock(); else openCompare(); break;
        case 'cmp-close': closeCompare(); break;
        case 'cmp-clear': state.picked = []; syncCmp(); paintDock(null); closeCompare(); break;
        case 'cmp-remove': toggleCompare(b.getAttribute('data-v')); break;
        case 'size': state.size = b.getAttribute('data-v'); paintGroup('size', state.size); paintGrid(); paintStudio({ drop: false }); paintCompare(); syncUrl(); break;
      }
    });
    // the picker is a listbox: arrows move and choose, Home and End jump
    pickRow.addEventListener('keydown', function (e) {
      var opts = $$('[role="option"]', pickRow), i = opts.indexOf(doc.activeElement);
      if (i === -1) return;
      var n = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: opts.length - 1 }[e.key];
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(opts[i].getAttribute('data-h')); return; }
      if (n == null) return;
      e.preventDefault();
      n = Math.max(0, Math.min(opts.length - 1, n));
      opts[n].focus();
      choose(opts[n].getAttribute('data-h'));
    });
    // segmented controls: arrows move between options, like radio groups
    $$('[data-pl-group]', root).forEach(function (g) {
      g.addEventListener('keydown', function (e) {
        var bs = $$('button', g), i = bs.indexOf(doc.activeElement);
        if (i === -1) return;
        var n = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1 }[e.key];
        if (n == null) return;
        e.preventDefault();
        n = (n + bs.length) % bs.length;
        bs[n].focus(); bs[n].click();
      });
    });
    // a source letter opens the sources list before the browser jumps to it
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a.pl-fnlink');
      var src = $('[data-pl-src]', root);
      if (a && src && !src.open) src.open = true;
    });
    sortSel.value = state.sort;
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; paintGrid(); });

    /* ----- start ----- */
    paintGroup('pos', state.pos); paintGroup('frame', state.frame); paintGroup('feel', state.feel); paintGroup('size', state.size);
    // open on the closest pillow that can be bought now (the server still is built for the same pick)
    state.pick = null;
    buildPick();
    var first = current();
    if (E && stage && first) {
      var f0 = loftFor(first);
      engine = E.mount(stage, { pos: state.pos, frame: state.frame, gap: gap(), sink: E.SINK[state.feel], loft: f0.v, fill: first.resp, adj: first.adj, loftText: inch(f0.v) });
    }
    paintStudio({ drop: false });
    paintGrid();
    paintDock(null);
  }

  function start() { $$('[data-pl]').forEach(boot); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
